import type { RootState } from "@/types";
import type { CpeAutoRapport, CpeAutoRapportHistory } from "@/types/cpe";
import type { CpeautorapportState } from "@/types/store";
import type { GetterTree } from "vuex";

export const getters: GetterTree<CpeautorapportState, RootState> = {
  getAutoCperapports(state): CpeAutoRapport[] {
    return state.cpeautorapports.data;
  },
  getAutoCperapportsCount(state): number {
    return state.cpeautorapports.count;
  },
  getAutoCperapportsLoading(state): boolean {
    return state.cpeautorapports.loading;
  },
  getAutoCperapportsError(state): string | null {
    return state.cpeautorapports.error;
  },
  getAutoCperapport(state): CpeAutoRapport {
    return state.cpeautorapport.data;
  },
  getAutoCperapportHistory(state): CpeAutoRapportHistory[] {
    return state.cpeautorapportshistory.data;
  },
  getAutoCperapportsHistoryLoading(state): boolean {
    return state.cpeautorapportshistory.loading;
  },
  getAutoCperapportsHistoryCount(state): number {
    return state.cpeautorapportshistory.count;
  },
};
